import { handleActions } from "redux-actions";

const tenantReducer = handleActions(
  {
    TENANT_GET: {
      FULFILLED: (state, action) => ({
        tenant: action.payload.tenant,
        initialTenant: action.payload.tenant,
      }),
    },
    TENANT_SAVE: {
      FULFILLED: (state, action) => ({
        tenant: action.payload.tenant,
        initialTenant: action.payload.tenant,
      }),
    },
  },
  {},
  { namespace: "_" }
);

export default tenantReducer;
